import { memo } from 'react'
import { Box, CircularProgress } from '@mui/material'
import PropTypes from 'prop-types'

/**
 * LoadingState component - Reusable loading indicator
 * @param {string} message - Optional loading message
 * @param {object} sx - Additional sx styles
 */
export const LoadingState = memo(({ message, sx }) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" p={3} sx={sx}>
      <CircularProgress aria-label={message || "Loading"} />
      {message && (
        <Box component="p" sx={{ mt: 2, color: 'text.secondary' }}>
          {message}
        </Box>
      )}
    </Box>
  )
})

LoadingState.propTypes = {
  message: PropTypes.string,
  sx: PropTypes.object,
}

LoadingState.displayName = 'LoadingState'
